import { module } from 'modujs'
import { CUSTOM_EVENT, ENV, VARS } from '../config'
import * as THREE from 'three'
// import { OrbitControls } from 'three/addons/controls/OrbitControls.js'
import { gsap } from '../gsap'

/**
 * Generic component to create Three.js Scene.
 *
 */
export default class AbstractScene extends module {
    constructor(m) {
        super(m)

        this.isDisabled = false
    }

    init() {

        // Resize event
        window.addEventListener(CUSTOM_EVENT.RESIZE_END, this.resizeBind = () => this.resize())

        // DOM
        this.$el = this.el

        // Vars
        this.sizes = {}

        // Scene
        this.scene = new THREE.Scene()

        // Camera
        this.camera = new THREE.PerspectiveCamera(75, 1)

        // // Controls
        // this.controls = new OrbitControls(this.camera, this.renderer.domElement)

        // Renderer
        this.renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true,
        })
        this.renderer.domElement?.setAttribute?.('aria-hidden', true)

        // Set sizes
        this.resize(false)

        // Callback
        this.onInit?.()

        // Clock
        this.clock = new THREE.Clock();

        // First render
        this.$el.appendChild(this.renderer.domElement)
        this.render()
    }

    start() {

        if(this.isDisabled || this.isTicking) {
            return
        }

        this.isTicking = true

        this.tickerBind = this.render.bind(this)
        gsap.ticker.add(this.tickerBind)

        this.onStart?.()
    }

    stop() {

        if(this.isDisabled || !this.isTicking) {
            return
        }

        this.isTicking = false
        gsap.ticker.remove(this.tickerBind)

        this.onStop?.()
    }

    toggle(e) {

        if(this.isDisabled) {
            return
        }

        if(e.way === 'enter' || (typeof e.way === 'undefined' && !this.isTicking)) {
            this.start()
        } else {
            this.stop()
        }

        this.onToggle?.()
    }

    resize(render=true) {

        // Callback
        this.onResize?.()

        if (this.isDisabled) {
            return
        }

        // Define sizes if undefined
        if(typeof this.sizes.width === 'undefined') {
            this.sizes.width = VARS.window.width
            this.sizes.height = VARS.window.height
        }

        // Update camera
        this.camera.aspect = this.sizes.width / this.sizes.height

        // Update renderer
        this.renderer.setSize(this.sizes.width, this.sizes.height)
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

        if(!this.isTicking && render) {
            this.render()
        }
    }

    render() {
        if(this.isDisabled) {
            return
        }

        const delta = this.clock.getDelta();
        const elapsed = this.clock.getElapsedTime();

        this.renderer?.render(this.scene, this.camera)
        this.camera?.updateProjectionMatrix()
        // this.controls?.update()

        // Callback
        this.onRender?.(delta, elapsed)
    }

    destroy() {
        this.stop()
        this.geometry?.dispose?.()
        this.material?.dispose?.()
        this.renderer?.dispose?.()
        window.removeEventListener(CUSTOM_EVENT.RESIZE_END, this.resizeBind)
    }
}
